import {toggleLockBody} from "../functions";

document.addEventListener('DOMContentLoaded', function (dom) {
    const navbar = dom.target.querySelector('.js-menu');
    const toggleMenu = dom.target.querySelector('.js-toggle-menu');
    if (navbar) {
        toggleMenu.addEventListener('click', function () {
            navbar.classList.toggle('active')
            toggleMenu.querySelector('i').classList.toggle('kb-icons-close')
            toggleMenu.querySelector('i').classList.toggle('kb-icons-menu')
            toggleLockBody()
        });
    }
})